import { env, buildEndpointUrl } from '@/lib/env'

const base = () => env.kuroSite.dataBaseUrl

export const kuroSiteApi = {
  overview: () => buildEndpointUrl(base(), 'overview.json'),
  now: () => buildEndpointUrl(base(), 'now.json'),
  postsIndex: () => buildEndpointUrl(base(), 'posts/index.json'),
  post: (slug: string) => buildEndpointUrl(base(), `posts/${slug}.json`),
}
